import React, { FC, ReactNode } from 'react'
import { useMessaging } from '@ucc/admin-messaging'

import { HIGHLIGHT_DELAY, HIGHLIGHT_DURATION } from 'utils/constants'

interface GlobalHighlightedElementProviderProps {
  children: ReactNode
}

const GlobalHighlightedElementProvider: FC<GlobalHighlightedElementProviderProps> = ({ children }) => {
  useMessaging('highlightedElementId', (payload: unknown) => {
    const el = document.createElement('style')
    el.insertAdjacentHTML(
      'afterbegin',
      `#${payload}:before {
            content: "";
            display: block;
            height: calc(100% + 32px);
            width: calc(100% + 32px);
            margin: -16px;
            z-index: -1;
            border-radius: 4px;
            position: absolute;
            animation: highlight ${HIGHLIGHT_DURATION}ms;
            animation-delay: ${HIGHLIGHT_DELAY}ms;
          }`,
    )
    document.head.append(el)

    setTimeout(() => {
      el.remove()
    }, HIGHLIGHT_DURATION + HIGHLIGHT_DELAY + HIGHLIGHT_DELAY * 2)
  })

  return <>{children}</>
}

export default GlobalHighlightedElementProvider
